export default "__VITE_ASSET__D$pWo6Ea__"